import { Body1, Caption, Subhead } from '@xo-union/tk-ui-typography';
import React from 'react';

import styles from './headline.scss';
import { Item, ItemProps } from './Item';

interface Props extends Omit<ItemProps, 'children'> {
  header?: string;
  text: string;
  size: 'large' | 'small';
}

export const HeadlineItem: React.FC<Props> = ({ onClick, header = 'Large Headline', text, size, ...rest }) => (
  <Item onClick={onClick} {...rest}>
    <div className={styles.container}>
      <Caption className={styles.title}>{header}</Caption>
      {size === 'large' ? <Subhead>{text}</Subhead> : <Body1>{text}</Body1>}
    </div>
  </Item>
);
